<template>
  <div>
    <div :class="[`u-shop-items-${layout}`, isDisabled && 'is-disabled']">
      <shop-product-list-item
        v-for="item in items"
        :key="`shop-item-${item.id}`"
        :item="item"
        :is-disabled="isDisabled"
        :is-processing="isProcessing"
        :truncate-length="truncateLength"
        :category-shortcut="categoryShortcut"
        :show-trials="showTrials"
        v-bind="$attrs"
        @routing="$emit('routing')"
        @addToBasket="$emit('addToBasket', $event)"
        @viewCategory="$emit('viewCategory', $event)"
      />
    </div>
    <div v-if="hasMore">
      <load-more :loading="isLoadingMore" @loadMore="$emit('loadMore')" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ShopItemsLayout } from "@/data/shop/enums";
import type { PropType } from "vue";
import type { IShopListItem } from "@/models/shop";

export default defineComponent({
  name: "ShopProductsVerticalList",
  components: {
    "shop-product-list-item": () =>
      import(
        "@/components/app/global/baskets/basket/shop/shopProductListItem.vue"
      )
  },
  props: {
    hasMore: { type: Boolean, required: true },
    items: { type: Array as PropType<IShopListItem[]>, default: () => [] },
    isLoadingMore: { type: Boolean, required: true },
    isDisabled: { type: Boolean, default: false },
    showHorizontal: { type: Boolean, default: false },
    categoryShortcut: { type: Boolean, default: false },
    showTrials: { type: Boolean, default: true },
    layout: {
      type: String as PropType<ShopItemsLayout>,
      default: ShopItemsLayout.VERTICAL
    }
  },
  data: () => ({
    isProcessing: {} as object
  }),
  computed: {
    truncateLength() {
      if (this.layout === ShopItemsLayout.HORIZONTAL) return 100;
      return 80;
    }
  }
});
</script>

<style lang="scss" scoped>
// VERTICAL
.u-shop-items-vertical {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
  gap: 2rem;
  .u-shop-item {
    display: grid;
    align-content: start;
    gap: 1rem;
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      "image"
      "details"
      "cta";
  }
}

// HORIZONTAL
.u-shop-items-horizontal {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  @media (min-width: 28.0625rem /* 449px */) {
    grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  }
  .u-shop-item {
    display: grid;
    align-items: start;
    gap: 1rem;

    @media (max-width: 28rem /* 448px */) {
      grid-template-columns: 1fr;
      grid-template-areas:
        "image"
        "details"
        "cta";
    }

    @media (min-width: 28.0625rem /* 449px */) {
      grid-template-columns: 6rem 1fr;
      grid-template-areas:
        "image details"
        "cta cta";
    }

    @include tablet {
      gap: 1rem;
      grid-template-columns: 10rem 1fr;
    }
  }
}
</style>
